<template>
    <footer>
        <div class="footerlogos">
            <div class="footerlogo-left">
                <a
                    href="https://www.chi-athenaeum.org/"
                    target="_blank"
                ><img
                    src="/images/gdn-logo.svg"
                ></a>
                <div class="footercontact">
                    601 South Prospect Street, Galena, Illinois 61036, USA<BR />
                    <strong>Tel:</strong> +1 815 777 4444
                    <strong>E-mail:</strong> contact@globaldesignnews.com,
                    orders@metropolitanartspress.com
                    <BR />
                    <a
                        href="https://globaldesignnews.com/"
                        target="_blank"
                    >globaldesignnews.com</a>
                    |
                    <a
                        href="https://metropolitanartspress.com/shop/"
                        target="_blank"
                    >metropolitanartspress.com</a>
                    |
                    <a
                        href="https://www.instagram.com/globaldesignnews/"
                        target="_blank"
                    >Instagram</a>
                    |
                    <a
                        href="https://www.facebook.com/globaldesignnews"
                        target="_blank"
                    >Facebook</a>
                </div>
            </div>
            <div class="footerlogo-right">
                <slot />
            </div>
        </div>
    </footer>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'

export default {
    name: 'Footer',
    methods: {},
    mounted() {},
    computed: {},
}
</script>
